module.exports = __webpack_public_path__ + "img/news.96076330.jpg";